<script setup lang="ts">
import MesIcon from '@/components/shared/MesIcon.vue';
import { isVNode } from 'vue'
import { useToast } from './use-toast'
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from '.'
import { CircleAlert, CircleCheck, Loader2 } from "lucide-vue-next";
import {useI18n} from "vue-i18n";

const { toasts } = useToast()
const {t} = useI18n()
</script>

<template>
  <ToastProvider>
    <Toast v-for="toast in toasts" :key="toast.id" v-bind="toast">
      <CircleAlert
        v-if="toast.variant === 'destructive' && !toast.notificationLoading"
        class="mt-1 h-5 w-5 shrink-0 self-start text-red-700 dark:text-red-300"
        aria-hidden="true"
      />
      <CircleCheck
        v-if="toast.variant === 'success' && !toast.notificationLoading"
        class="mt-1 h-5 w-5 shrink-0 self-start text-green-700 dark:text-green-300"
        aria-hidden="true"
      />
      <div class="grid min-w-0 flex-1 gap-1">
        <ToastTitle v-if="toast.title">
          {{ toast.notificationLoading ? t('processing') + ' ' + toast.title : toast.title }}
        </ToastTitle>
        <template v-if="toast.notificationLoading">
          <ToastDescription class="flex">
            <MesIcon name="Loader2" motion="loading" class="mr-2 h-5 w-5 "/>
            <span>
              {{ t('please_wait.one') }}
            </span>
          </ToastDescription>
        </template>
        <div v-else>
          <template v-if="toast.description">
            <ToastDescription v-if="isVNode(toast.description)">
              <component :is="toast.description" />
            </ToastDescription>
            <ToastDescription class="flex" v-else>
              <MesIcon name="Loader2" motion="loading" class="mr-2 h-5 w-5 " v-if="toast.notificationLoading"/>
              <span v-if="toast.notificationLoading">
              {{ t('please_wait.one') }}
            </span>
              <span v-else>
              {{ toast.description }}
            </span>
            </ToastDescription>
          </template>
        </div>
        <ToastClose :aria-label="t('close')" />
      </div>
      <component :is="toast.action" />
    </Toast>
    <ToastViewport />
  </ToastProvider>
</template>
